export const mode = 'stage';
export const IMP_CODE = 'imp57184657'
export const IMP_PG = 'html5_inicis.MOImonster'
export const STORAGE_ENCRYPTION_KEY = 'B9wzu2VyL8H7fCWKGdNZCuRBmNQAmfTq'

export const IMP_PG_KAKAOPAY_PAYMENT = 'kakaopay.CA88AA6ACB'
export const IMP_PG_KAKAOPAY_BILLING = 'kakaopay.CADA287AB2'

export const IMP_PG_PAYPAL_BILLING = 'paypal_v2.WBZEGE67SLH36'